export default function minTranslate() {
  return -this.snapGrid[0];
}



// WEBPACK FOOTER //
// ../src/core/translate/minTranslate.js